/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Vo_Track_FailedInputs */



/**
* | output |
* | --- |
* | "Error exporting VO Track" |
*
* @param {Audio_Description_Export_Vo_Track_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_vo_track_failed = /** @type {((inputs?: Audio_Description_Export_Vo_Track_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Vo_Track_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors de l'export de la piste VO")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Exportieren der Sprachspur")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante l'esportazione della traccia VO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при экспорте аудиодорожки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al exportar la pista VO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出语音轨道时出错")
	if (locale === "ja") return /** @type {LocalizedString} */ ("VOトラックのエクスポート中にエラーが発生しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीओ ट्रैक निर्यात करने में त्रुटि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao exportar a faixa de voz")
	return /** @type {LocalizedString} */ ("Error exporting VO Track")
});